import { styled } from '@spazious/dollhouse-theme';

import { ButtonBase } from '../Button/index.js';
import { Stack, StackProps } from '../Stack/index.js';

export interface ButtonGroupProps extends StackProps {
  outlined?: boolean;
}

export const ButtonGroup = styled(Stack).withConfig({
  shouldForwardProp: (prop) => !['outlined'].includes(prop),
  displayName: 'ButtonGroup',
})<ButtonGroupProps>`
  background-color: var(--spz-sys-color-surface-container);
  border-radius: var(--shape-rounded-radius);
  transition: background-color 0.3s ease-in-out;
  justify-content: space-between;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border: ${({ outlined }) => (outlined ? '1px solid var(--spz-sys-color-outline)' : 'none')};
  flex-direction: ${({ direction = 'row' }) => direction};
  gap: 0;
  > ${ButtonBase} {
    box-shadow: none;
    flex: 1;
    border-right: ${({ outlined }) =>
      outlined ? '1px solid var(--spz-sys-color-outline)' : 'none'};
  }
  > ${ButtonBase}:first-of-type {
    // Border radius for the first and last button
    ${({ column, flexDirection }) =>
      column || flexDirection === 'column' || flexDirection === 'column-reverse'
        ? `
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        `
        : `
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        
      `};
  }
  > ${ButtonBase}:last-of-type {
    border-right: none;
    ${({ column, flexDirection }) =>
      column || flexDirection === 'column' || flexDirection === 'column-reverse'
        ? `
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        `
        : `
         border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      `};
  }
  > ${ButtonBase}:not(:last-of-type):not(:first-of-type) {
    border-radius: 0;
  }
`;
